import React from "react";
import PropTypes from "prop-types";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const AiChart = ({ chartType, data, options }) => {
  // Prepare chart data
  // const chartData = {
  //   labels: datas[0], // First array in datas is used for labels (e.g., months)
  //   datasets: [
  //     {
  //       label: labels[1], // Second label (e.g., 'Total Sales')
  //       data: datas[1], // Second array in datas is used for values
  //       backgroundColor:
  //         chartType === "bar"
  //           ? "rgba(75, 192, 192, 0.6)"
  //           : "rgba(75, 192, 192, 0.2)",
  //       borderColor: "rgba(75, 192, 192, 1)",
  //       borderWidth: 1,
  //     },
  //   ],
  // };

  // Adjust background colors for pie/doughnut charts
  // if (chartType === "pie" || chartType === "doughnut") {
  //   chartData.datasets[0].backgroundColor = [
  //     "rgba(255, 99, 132, 0.6)",
  //     "rgba(54, 162, 235, 0.6)",
  //     "rgba(255, 206, 86, 0.6)",
  //     "rgba(75, 192, 192, 0.6)",
  //     "rgba(153, 102, 255, 0.6)",
  //     "rgba(255, 159, 64, 0.6)",
  //   ].slice(0, datas[0].length);
  // }

  return (
    <div>
      <Chart type={chartType} data={data} options={options} />
    </div>
  );
};

// PropTypes for type checking
AiChart.propTypes = {
  chartType: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
};

// Default props (optional)
AiChart.defaultProps = {
  chartType: "line",
};

export default AiChart;
